module.exports = __webpack_public_path__ + "4507a56813b58e77f4ac24db7afd3b8a.jpg";